// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__iEfhR","Header":"Modal_Header__sHwvp","Title":"Modal_Title__cRkfV","Overlay":"Modal_Overlay__-7mEq","CloseButton":"Modal_CloseButton__tlYip"};